<template>
  <div>
    <div class="live_chatting_list_wrapper__a5XTV">
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(234, 163, 95)"
                ><span class=""><span class="name_text__yQG50">쌍룡냥이</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(225, 100, 144)"
                ><span class=""><span class="name_text__yQG50">청허공</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">그런거 한번씩 있죠 ㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(225, 100, 144)"
                ><span class=""><span class="name_text__yQG50">청허공</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">옆사람 핸드폰 벨소리 하루종일 흥얼거림ㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(234, 163, 95)"
                ><span class=""><span class="name_text__yQG50">쌍룡냥이</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">난 누군가 또 여깅 어딘가</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(179, 219, 180)"
                ><span class=""><span class="name_text__yQG50">바꾸휘</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">뵥하!</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(225, 100, 144)"
                ><span class=""><span class="name_text__yQG50">청허공</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㄷㄷ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(225, 100, 144)"
                ><span class=""><span class="name_text__yQG50">청허공</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">그 짝궁 이름이 돌침대였나요</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 206, 142)"
                ><span class=""><span class="name_text__yQG50">제찬</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">전염이야</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(179, 219, 180)"
                ><span class=""><span class="name_text__yQG50">Windwave</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">복하~</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(225, 100, 144)"
                ><span class=""><span class="name_text__yQG50">청허공</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">한번 머리에 빡 꽂히면</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(179, 219, 180)"
                ><span class=""><span class="name_text__yQG50">Windwave</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">jm님 비전프로 한국 사람 중 최초 수령하신 듯...</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(179, 219, 180)"
                ><span class=""><span class="name_text__yQG50">Windwave</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">아뇨</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(179, 219, 180)"
                ><span class=""><span class="name_text__yQG50">Windwave</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH"
              >일본이신데... 픽업 매장 미국으로 선택하셔서 받으러 가심</span
            >
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(113, 125, 198)"
                ><span class=""><span class="name_text__yQG50">Hahihuhaeho</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">배터리 얼마나 가려나</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(179, 219, 180)"
                ><span class=""><span class="name_text__yQG50">Windwave</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH"
              >택배로 받을 수 있는데 몇일 소요 되니깐 그냥 미국으로 픽업가ㅅ셨음</span
            >
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(98, 141, 204)"
                ><span class=""><span class="name_text__yQG50">SKTT1WOLF</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">치지직 아픈가</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(98, 141, 204)"
                ><span class=""><span class="name_text__yQG50">SKTT1WOLF</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">지금왔는데 뭐 보심?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(144, 95, 170)"
                ><span class=""><span class="name_text__yQG50">낚시왕 삼촌 465</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">미국</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(98, 141, 204)"
                ><span class=""><span class="name_text__yQG50">SKTT1WOLF</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">편도?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">여행가시는건가</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">31시간인데?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(98, 141, 204)"
                ><span class=""><span class="name_text__yQG50">SKTT1WOLF</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">31시간?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">그냥 나리타 경유인가</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">192개국 무비자 입국가능이니까</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">헉</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(113, 125, 198)"
                ><span class=""><span class="name_text__yQG50">Hahihuhaeho</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">연금복권도 5000원구매 한도인가</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(113, 125, 198)"
                ><span class=""><span class="name_text__yQG50">Hahihuhaeho</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">인터넷은</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(234, 114, 61)"
                ><span class=""><span class="name_text__yQG50">gahareu2</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">불법 도박 사이트처럼 생겼네</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(234, 114, 61)"
                ><span class=""><span class="name_text__yQG50">gahareu2</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">안그래도 형 수염 자라서</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(234, 114, 61)"
                ><span class=""><span class="name_text__yQG50">gahareu2</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">더 그렇게 보임</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(145, 203, 198)"
                ><span class=""><span class="name_text__yQG50">샤를펠릭스</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">요샌 복권도 인터넷으로 할수있나</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">돈 많이 버시오</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(231, 109, 83)"
                ><span class=""><span class="name_text__yQG50">싸이월드 cyworld</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">맞긴해 ㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(132, 193, 148)"
                ><span class=""><span class="name_text__yQG50">루나루비</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">현금만 가능 카드는 안될거에욥</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(146, 200, 150)"
                ><span class=""><span class="name_text__yQG50">티르핑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">복하</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">같은거 세마리</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(233, 127, 88)"
                ><span class=""><span class="name_text__yQG50">따악효니</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">누르면 돈이 나온다고 ㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(233, 127, 88)"
                ><span class=""><span class="name_text__yQG50">따악효니</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">아 이런거구나</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">만원만 나와도 20배야</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">세개</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(233, 127, 88)"
                ><span class=""><span class="name_text__yQG50">따악효니</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">살퍄</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">또이또이네</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(233, 127, 88)"
                ><span class=""><span class="name_text__yQG50">따악효니</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">실패다</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">배수</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw live_chatting_list_guide__JdK7+">
        <div class="live_chatting_guide_container__vr6hZ live_chatting_guide_welcome__o8iup">
          <em>채팅방에 오신 것을 환영합니다!</em>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw live_chatting_list_guide__JdK7+">
        <div class="live_chatting_guide_container__vr6hZ live_chatting_guide_filter__BJDve">
          <div class="live_chatting_guide_inner__TK3wg">
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="live_chatting_guide_icon__HX2cT"
              aria-hidden="true"
            >
              <g filter="url(#filter0_d_1359_39595)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.25 2.80217C9.58609 3.24713 8.78948 3.61735 7.88218 3.91479C6.80169 4.269 5.63313 4.49881 4.46257 4.62659C4.15425 4.66025 3.86268 4.68486 3.59227 4.70177L3.03206 4.72699L2.91697 4.7286C2.41068 4.72835 2 5.13883 2 5.64527V8.71575C2 9.25866 2.46923 9.68262 3.00936 9.62772C5.62244 9.36213 7.735 9.6419 9.39895 10.2983C9.71773 10.4241 10.001 10.5549 10.25 10.6858V2.80217ZM11.625 11.6744C12.2029 12.0141 13 11.6135 13 10.8782V2.41668C13 1.67714 12.1991 1.28279 11.625 1.61993V11.6744Z"
                  fill="#DFE2EA"
                ></path>
                <rect x="4.1" y="7.6" width="3.8" height="4.75833" rx="1.9" stroke="#DFE2EA" stroke-width="1.2"></rect>
              </g>
              <defs>
                <filter
                  id="filter0_d_1359_39595"
                  x="1"
                  y="1.49817"
                  width="13"
                  height="13.4601"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  ></feColorMatrix>
                  <feOffset dy="1"></feOffset>
                  <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"></feColorMatrix>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1359_39595"></feBlend>
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1359_39595"
                    result="shape"
                  ></feBlend>
                </filter>
              </defs>
            </svg>
            <span class="blind">공지</span>
            <p>쾌적한 시청 환경을 위해 일부 메시지는 필터링 됩니다. 클린 라이브 채팅 문화 만들기에 동참해 주세요.</p>
          </div>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(233, 127, 88)"
                ><span class=""><span class="name_text__yQG50">따악효니</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">배팅 5배로 한거나 마찬가지인듯</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">당첨금액의 5배</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">꽝도 있어?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(131, 195, 187)"
                ><span class=""><span class="name_text__yQG50">깜수늬</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">푸하하</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">근데 진짜 도박을 만들어놨어..</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(228, 129, 174)"
                ><span class=""><span class="name_text__yQG50">BURI</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">본전도 아닌데 ㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">무한으로 즐겨요</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">zzzzzzzzzz</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">오</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">오</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(228, 129, 174)"
                ><span class=""><span class="name_text__yQG50">BURI</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">오</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH"
              >아니 근데 이게 도박이 아니라고? ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ</span
            >
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">백만원?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(131, 195, 187)"
                ><span class=""><span class="name_text__yQG50">깜수늬</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">양각</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(129, 161, 202)"
                ><span class=""><span class="name_text__yQG50">민트초코호떡</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">가즈아</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(214, 108, 180)"
                ><span class=""><span class="name_text__yQG50">중증도파민중독자</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">투페어 ㄷㄷ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">'그년'</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(228, 129, 174)"
                ><span class=""><span class="name_text__yQG50">BURI</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(228, 129, 174)"
                ><span class=""><span class="name_text__yQG50">BURI</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">그년 ㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(131, 195, 187)"
                ><span class=""><span class="name_text__yQG50">깜수늬</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(129, 161, 202)"
                ><span class=""><span class="name_text__yQG50">민트초코호떡</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">그래도 꿈은 꾸게 해주는년</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(131, 195, 187)"
                ><span class=""><span class="name_text__yQG50">깜수늬</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">아이</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y live_chatting_message_is_hidden__CLKiR">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">클린봇이 부적절한 표현을 감지했습니다.</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(234, 114, 61)"
                ><span class=""><span class="name_text__yQG50">뱃살맨</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">이게 빠칭코랑 다른게 뭐임?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(225, 100, 144)"
                ><span class=""><span class="name_text__yQG50">청허공</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">도파민 덜주는 배너로드로</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/cheese01.png"
                      alt="밥 잘 사주는 예쁜 팬"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(208, 113, 182)"
                ><span class=""><span class="name_text__yQG50">블랙오랜지</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">ㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(233, 127, 88)"
                ><span class=""><span class="name_text__yQG50">따악효니</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">대지직</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">이야</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(159, 153, 200)"
                ><span class=""><span class="name_text__yQG50">백이랑</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">어디서 그렇게 번거지</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">네이버가 카카오보다 경영 잘해</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(129, 161, 202)"
                ><span class=""><span class="name_text__yQG50">나코이</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">전폭 지원한다던데 ㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(129, 161, 202)"
                ><span class=""><span class="name_text__yQG50">나코이</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">연계?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(121, 148, 208)"
                ><span class=""><span class="name_text__yQG50">독야명월</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">네이버를 열고</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">캬</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">열린 네이버</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(225, 100, 144)"
                ><span class=""><span class="name_text__yQG50">샤코1</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH"
              >9년만에 한국이 아시안컵 8강에서 호주에게 설욕을 성공시킵니다!!!!</span
            >
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(131, 195, 187)"
                ><span class=""><span class="name_text__yQG50">깜수늬</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH"
              >도현님 어머니가 엄청 좋아했다고 아들 네이버 대기업 다닌다고 자랑 가능하다고</span
            >
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(225, 100, 144)"
                ><span class=""><span class="name_text__yQG50">샤코1</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">호주탈락!!!!</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH"
              >네이버는 뭐라고 부르나요 개복어님이라 부르나요 본명으로 부르나요</span
            >
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(121, 148, 208)"
                ><span class=""><span class="name_text__yQG50">독야명월</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">그중에 하나가 치지직?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(121, 148, 208)"
                ><span class=""><span class="name_text__yQG50">독야명월</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">비슷하게 ㅎㅎㅎ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(230, 109, 95)"
                ><span class=""><span class="name_text__yQG50">플레이아</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">카카시야?</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(121, 148, 208)"
                ><span class=""><span class="name_text__yQG50">독야명월</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">폐쇄를 안해 ㅋㅋㅋㅋㅋ</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(204, 229, 125)"
                ><span class=""><span class="name_text__yQG50">Vera27</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">그런 네이버가 없애버린 인기검색어는 도대체</span>
          </button>
        </div>
      </div>
      <div class="live_chatting_list_item__0SGhw">
        <div class="live_chatting_message_container__vrI-y">
          <button type="button" class="live_chatting_message_wrapper__xpYre" aria-haspopup="true" aria-expanded="false">
            <span
              class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
              style="margin-right: 4px"
              ><span class="live_chatting_username_wrapper__iJpJB"
                ><span class="live_chatting_username_icon__6Dj7b"
                  ><span class="badge_container__a64XB"
                    ><img
                      src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png"
                      alt="입덕 완료"
                      width="18"
                      height="18" /></span></span></span
              ><span class="live_chatting_username_nickname__dDbbj" style="color: rgb(131, 195, 187)"
                ><span class=""><span class="name_text__yQG50">깜수늬</span></span></span
              ></span
            ><span class="live_chatting_message_text__DyleH">남들 지쳐떨어질때 까지 기다림</span>
          </button>
        </div>
      </div>
      <div style="width: 100%; height: 1px; min-height: 1px"></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const targetEls = [...this.$el.querySelectorAll(".live_chatting_message_container__vrI-y")];

    const messages = targetEls.map((el) => {
      try {
        const message = el.querySelector(".live_chatting_message_text__DyleH").innerText;
        const nickname = el.querySelector(".live_chatting_username_nickname__dDbbj").innerText;
        const isFan = el.querySelector("img") ? true : false;
        const color = el.querySelector(".live_chatting_username_nickname__dDbbj").style.color;

        return {
          name: nickname,
          message: message,
          isFan,
          color,
        };
      } catch (error) {
        console.log(error);
        return {};
      }
    });

    console.log(JSON.stringify(messages));
  },
};
</script>

<style></style>
